<template>
    <div id="">
        <div>
            <button @click="openModal" class="primaryButton">
                {{ openButtonText }}
            </button>
        </div>
        <p>The upload destination will be the {{ srcAddress }}, so please make sure that is filled out and accurate.</p>
        <div class="modal" @click.self="closeModal" v-if="modalActive">
            <div class="modalForm">
                <h2 class="modalTitle">{{ modalTitle }}</h2>
                <div>
                    <input type="file" ref="fileUpload" :accept="acceptFileTypes" @change="allowUpload = true"/>
                </div>
                <div v-if="!permission">
                    <h4>Access</h4>
                    <select v-model="permission_local">
                        <option value="public-read">Public</option>
                        <option value="private">Private</option>
                    </select>
                </div>
                <div class="flexRow" style="justify-content: space-between;">
                    <button @click="closeModal" class="cancelButton">Cancel</button>
                    <button @click="uploadFile" class="primaryButton" :disabled="!allowUpload || uploading">Upload</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {storage} from '../../shared/storage';

export default {
    name: 'UploadMediaPropertyModal',
    props: {
        openButtonText: {
            type: String,
            required: true
        },
        modalTitle: {
            type: String,
            required: true
        },
        fileKey: {
            type: String,
            required: true
        },
        acceptFileTypes: {
            type: String
        },
        onFileUpload: {
            type: Function
        },
        permission: {
            type: String,
            default: null
        },
        srcAddress: {
            type: String,
            default: 'Src URL'
        }
    },
    data() {
        return {
            modalActive: false,
            allowUpload: false,
            uploading: false,
            permission_local: "public-read"
        }
    },
    computed: {
        bucketName() {
            switch(window.location.hostname) {
                case 'localhost':
                case 'admin-jv-custom-solutions-dev.herokuapp.com':
                    return 'jv.development';
                case 'admin-jv-custom-solutions-qa.herokuapp.com':
                    return 'jv.qa.new';
                case 'admin.jellyvisioncustom.com':
                    return 'jv.production';
                default:
                    return undefined;
            }
        }
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if(!this.modalActive) return;
            if (e.key == 'Enter')
                this.uploadFile();
            if (e.key == 'Escape')
                this.closeModal();
        });
    },
    methods: {
        openModal: function() {
            this.modalActive = true;
        },
        closeModal: function() {
            this.modalActive = false;
            this.uploading = false;
            this.$refs.fileUpload.value = null;
        },
        uploadFile: async function() {
            if(!this.allowUpload) return;
            this.uploading = true;
            let key_local = this.fileKey;
            if(key_local.charAt(0) === '/')
                key_local = key_local.substring(1);
            const resp = await data.uploadStorageObject(this.$refs.fileUpload.files[0], storage.bucketName(), key_local, this.permission ?? this.permission_local)
            if(resp.success) {
                if(this.onFileUpload)
                    this.onFileUpload(this.fileKey);
                this.closeModal();
            } else if(resp.errors) {
                this.$toast.error(resp.errors);
                this.uploading = false;
            }
        }
    }
}
</script>

<style scoped>
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .modalForm {
        position: relative;
        border: 1px solid lightgray;
        background-color: white;
        width: 400px;
        padding: 20px;
        text-align: left;
        height: 165px;
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 20;
        display: flex;
        flex-direction: column;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    .cancelButton {
        height: 40px;
        width: 150px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
    }
    .primaryButton {
        border-radius: 5px;
        border-color: #036991;
        background-color: #036991;
        color: white;
        cursor: pointer;
        padding: 8px 24px;
        font-size: 16px;
    }
    .primaryButton:disabled {
        cursor:default;
        background-color: lightgrey;
        border-color: rgb(239, 239, 239);
    }
</style>